import { render, staticRenderFns } from "./WorkflowFormBuilderDetailStateCard.vue?vue&type=template&id=453e321e&"
import script from "./WorkflowFormBuilderDetailStateCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderDetailStateCard.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormBuilderDetailStateCard.vue?vue&type=style&index=0&id=453e321e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports